import "./styles.css";
import "./styles/globals.css";
import RouterBuilder from "./App.router";
import LoginSignUpPage from "./layouts/LoginPage";
import { whoAmIResponse } from "@models/project";
import { withAuthInfo } from "@propelauth/react";
import { useState, useMemo } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { whoAmI } from "./api/whoIAm_api";
import BaseLoadingSpinner from "./components/ui/baseLoadingSpinner";

const App = withAuthInfo(({ isLoggedIn, accessToken }) => {
    const [response, setResponse] = useState<whoAmIResponse | null>(null);

    /**
     * In theory, this should only run once, when the user logs in.
     * baiscally I want to do nothing if the token changes, but isLoggedin is still true.
     *
     * This will work as long as downstream, I am always pulling the token from the auth context.
     *
     * so we useMemo on the isLoggedIn
     *
     * */
    if (isLoggedIn) {
        useMemo(() => {
            whoAmI(accessToken)
                .then((data) => {
                setResponse(data);
                console.log('whoAmI', data)
            }).catch((err) => {
                console.log('error', err)
            });
        }, [isLoggedIn]);

        if (!response) {
            return <BaseLoadingSpinner/>
        } else {
            const routes = RouterBuilder(response);
            return <RouterProvider router={createBrowserRouter(routes)} />;
        }
    } else {
        return LoginSignUpPage();
    }
});

export default App;
